/* ============
 * Actions for the modal module
 * ============
 *
 * The actions that are available on the
 * modal module.
 */

import { ModalComponentName } from '@/components/Modal/types'

import { CLOSE_MODAL, SET_OPTIONS, SHOW_MODAL } from './mutation-types.js'

export default {
  open,
  close,
  setOptions
}

export async function open({ commit }, componentName) {
  await commit(SHOW_MODAL, componentName)
}

export async function close({ commit }, name) {
  await commit(CLOSE_MODAL)
  if (name === ModalComponentName.PROMO) {
    localStorage.setItem('promoPopupClosed', 'true')
  } else if (name === ModalComponentName.PROMO_NOT_REGISTERED) {
    localStorage.setItem('promoPopupNotRegisteredClosed', 'true')
  }
}

export async function setOptions({ commit }, options) {
  await commit(SET_OPTIONS, options)
}
